import styled from 'styled-components';

import { pxToRem, StatusColor } from 'utils/scss';

export const ModalContainer = styled.div`
  padding: ${pxToRem('64px')} 0;
`;

export const ModalContent = styled.div`
  text-align: center;
  border-radius: ${pxToRem('30px')};
  background-color: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const IconWrapper = styled.div`
  float: right;
  margin-right: ${pxToRem('20px')};

  :hover {
    cursor: pointer;
  }
`;

export const StatusContainer = styled.span`
  font-family: OpenSans;
  margin: 0 ${pxToRem('8px')}
  text-transform: uppercase;
  ${props => props.type && StatusColor(props.type)}
  border-radius: ${pxToRem('20px')};
  padding: ${pxToRem('6px')} ${pxToRem('24px')};
  height: ${pxToRem('28px')};
  font-size: ${pxToRem('12px')};
  font-weight: bold;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: ${pxToRem('2px')};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;
